import React, { useState } from 'react';

import MyAccountTabs from 'layouts/MyAccountTabs';
import Notification from 'components/Notification';
import DeleteAccount from 'components/DeleteAccount';

import { tabItems } from '.';
import ProfileService from 'services/ProfileService';
import { useRouter } from 'next/router';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { withAuth } from 'features/auth/withAuth';

function Privacy() {
  const router = useRouter();
  const [notification, setNotification] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuthUser();
  const profileService = new ProfileService();

  async function deleteAccount() {
    setIsLoading(true);

    try {
      await profileService.deleteAccount();
      setIsLoading(false);
      setNotification('The account was sucessfully deleted. You will be logged out soon.');
      setTimeout(() => {
        router.push('/auth/logout');
      }, 4000);
    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setNotification(error.response.data.message);
        return;
      }
    }
  }

  return (
    <>
      <MyAccountTabs title="Delete my account" tabItems={tabItems}>
        <DeleteAccount user={user} onSave={deleteAccount} isLoading={isLoading} />

        <Notification
          isOpen={!!notification}
          message={notification}
          onClose={() => setNotification('')}
        />
      </MyAccountTabs>
    </>
  );
}

export default withAuth(Privacy);
